import React from 'react';
import { DashChartProps } from '../DashCard';

const DashLabel: React.FC<DashChartProps> = ({ item }) => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>{item.title}</h1>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center', // Horizontally center
        alignItems: 'center', // Vertically center
        width: '100%', // Full width
        height: '100%', // Full height
        textAlign: 'center', // Center the text
    },
    title: {
        fontSize: '2rem', // Larger than normal h1
        fontWeight: 'bold',
        textDecoration: 'underline',
        color: '#6A1B9A', // Darker color for readability
        margin: '0', // Remove margin for better centering
    },
};

export default DashLabel;